import { forwardRef, type ButtonHTMLAttributes, type ReactNode } from 'react';
import { cn } from '../foundation/cn';

export interface IconButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  readonly label: string;
  readonly icon: ReactNode;
  readonly size?: 'sm' | 'md';
}

const SIZE = {
  sm: 'h-8 w-8',
  md: 'h-10 w-10',
} as const;

// Icon-only button. `label` is required and mapped to aria-label for accessibility.
export const IconButton = forwardRef<HTMLButtonElement, IconButtonProps>(function IconButton(
  { label, icon, size = 'md', className, ...rest },
  ref,
) {
  return (
    <button
      ref={ref}
      aria-label={label}
      title={label}
      className={cn(
        'inline-flex items-center justify-center rounded-token text-fg',
        'transition-colors duration-fast ease-standard hover:bg-surface-muted',
        'focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary',
        'disabled:cursor-not-allowed disabled:opacity-60',
        SIZE[size],
        className,
      )}
      {...rest}
    >
      {icon}
    </button>
  );
});
